import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2026 The Spur Ventures. All rights reserved.</p>
        <p>University of Nebraska-Lincoln • Biological Systems Engineering</p>

        <div className="footer-credit">
          <span className="footer-credit-label">Website developed by</span>
          <strong className="footer-credit-name">Sai Charith Vaitla</strong>
          <span className="footer-credit-role">
            AI Workflow Engineer • Biological Systems Engineering •
            University of Nebraska–Lincoln (UNL)
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
